// deno-lint-ignore-file no-window
import * as Phaser from "phaser";
import * as twaSDK from "@telegram-apps/sdk";
// Scenes
import { LoadingScene } from "./scenes/loading/LoadingScene.ts";
import { PreloadScene } from "./scenes/loading/PreloadScene.ts";
import { PetCreateScene } from "./scenes/PetCreateScene.ts";
import { PetDeathScene } from "./scenes/PetDeathScene.ts";
import { PetHomeScene } from "./scenes/PetHomeScene.ts";
import { CurrencyShopScene } from "./scenes/CurrencyShopScene.ts";
// mini-games
import { EggBrakeScene } from "./scenes/mini-games/EggBrakeScene.ts";
import { CatchFoodGameScene } from "./scenes/mini-games/CatchFoodGameScene.ts";
import { MiniGamesListScene } from "./scenes/mini-games/MiniGamesListScene.ts";
// Overlays
import { MainSettingsOverlay } from "./scenes/overlays/MainSettingsOverlay.ts";
import { GameOverOverlay } from "./scenes/overlays/GameOverOverlay.ts";
import { LoadingOverlay } from "./scenes/overlays/LoadingOverlay.ts";
import { StatRestoreOverlay } from "./scenes/overlays/StatRestoreOverlay.ts";
import { FoodShopOverlay } from "./scenes/overlays/FoodShopOverlay.ts";
import { ContinueGameOverlay } from "./scenes/overlays/ContinueGameOverlay.ts";
// Global plugins
import { ApiGlobalPlugin } from "./plugins/ApiGlobalPlugin.ts";
import { StorageGlobalPlugin } from "./plugins/StorageGlobalPlugin.ts";
import { CommonVarsGlobalPlugin } from "./plugins/CommonVarsGlobalPlugin.ts";
import { TelegramGlobalPlugin } from "./plugins/TelegramGlobalPlugin.ts";
import { SettingsGlobalPlugin } from "./plugins/SettingsGlobalPlugin.ts";
import { SoundManagerGlobalPlugin } from "./plugins/SoundManagerGlobalPlugin.ts";
import { KeysManagerGlobalPlugin } from "./plugins/KeysManagerGlobalPlugin.ts";
// Scene plugins
import { OverlayScenePlugin } from "./plugins/OverlayScenePlugin.ts";
import { TransitionScenePlugin } from "./plugins/TransitionScenePlugin.ts";
import { BasicOverlay } from "./prefabs/scenes/overlays/BasicOverlay.ts";

let gameCreated = false;

export const getPhaserConfig = () => {
  const viewportHeight = window.innerHeight;
  const aspectRatio = viewportHeight / window.innerWidth;
  const calculatedHeight = window.tunerTwaConfig.game.virtualWidth *
    aspectRatio;
  const virtualHeight = Math.max(640, calculatedHeight);

  const PhaserConfig: Phaser.Types.Core.GameConfig = {
    type: Phaser.WEBGL,
    width: window.tunerTwaConfig.game.virtualWidth,
    height: virtualHeight,
    parent: "game-container",
    backgroundColor: window.tunerTwaConfig.headerColor,
    dom: {
      createContainer: true,
    },
    plugins: {
      scene: [{
        key: "overlay",
        plugin: OverlayScenePlugin,
        mapping: "overlay",
        start: true,
      }, {
        key: "transition",
        plugin: TransitionScenePlugin,
        mapping: "transition",
        start: true,
      }],
      global: [{
        key: "globalVars",
        plugin: CommonVarsGlobalPlugin,
        start: true,
      }, {
        key: "api",
        plugin: ApiGlobalPlugin,
        start: true,
      }, {
        key: "storage",
        plugin: StorageGlobalPlugin,
        start: true,
      }, {
        key: "telegram",
        plugin: TelegramGlobalPlugin,
        start: true,
      }, {
        key: "settings",
        plugin: SettingsGlobalPlugin,
        start: true,
      }, {
        key: "soundManager",
        plugin: SoundManagerGlobalPlugin,
        start: true,
      }, {
        key: "keysManager",
        plugin: KeysManagerGlobalPlugin,
        start: true,
      }],
    },
    scene: [
      // Loading scenes
      PreloadScene,
      LoadingScene,
      //
      PetCreateScene,
      PetDeathScene,
      PetHomeScene,
      CurrencyShopScene,
      // Mini-games
      EggBrakeScene,
      CatchFoodGameScene,
      MiniGamesListScene,
      // Overlays
      BasicOverlay,
      MainSettingsOverlay,
      GameOverOverlay,
      LoadingOverlay,
      StatRestoreOverlay,
      FoodShopOverlay,
      ContinueGameOverlay,
    ],
    physics: {
      default: "arcade",
      matter: {
        gravity: { x: 0, y: 0 },
        debug: true,
      },
      arcade: {
        debug: true,
      },
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    render: {
      antialias: true,
      pixelArt: false,
      roundPixels: false,
    },
  };

  return PhaserConfig;
};

/**
 * Asynchronously loads the AdsGram script after the main game has loaded
 * This prevents blocking the initial game load if the ads script fails
 */
const loadAdsGramScript = () => {
  const script = document.createElement("script");
  script.src = "https://sad.adsgram.ai/js/sad.min.js";
  script.async = true;

  script.onload = () => {
    console.log("AdsGram script loaded successfully");
    // Dispatch event to notify that AdsGram is ready
    window.dispatchEvent(new CustomEvent("adsgram-loaded"));
  };

  script.onerror = (error) => {
    console.warn(
      "Failed to load AdsGram script, continuing without ads support:",
      error,
    );
    // Dispatch event to notify that AdsGram failed to load
    window.dispatchEvent(new CustomEvent("adsgram-error", { detail: error }));
  };

  document.head.appendChild(script);
};

const createGame = () => {
  if (gameCreated) return;
  gameCreated = true;
  const game = new Phaser.Game(getPhaserConfig());

  // Load AdsGram script asynchronously after game creation
  loadAdsGramScript();

  return game;
};

const initGame = () => {
  if (window.Telegram.WebApp.initData !== "") {
    window.Telegram.WebApp.setHeaderColor(window.tunerTwaConfig.headerColor);

    twaSDK.init();

    

    if (twaSDK.isViewportExpanded()) {
      createGame();
    } else {
      twaSDK.expandViewport();

      // TODO: обосратый мегакостыль
      setTimeout(() => {
        createGame();
      }, 1000);
    }
  } else {
    alert("⚠️ Telegram WebApp not detected. Fallback mode.");
  }
};

initGame();
